import registerServiceWorker from './registerServiceWorker'
export default registerServiceWorker
